import sellOnInstagram from "./sell-on-instagram-dms-without-losing-orders";
import commentToDm from "./comment-to-dm-instagram-orders";
import storyReplies from "./instagram-story-replies-that-sell";
import acceptPayments from "./accept-payments-instagram-upi-vs-gateway";
import abandonedCarts from "./abandoned-carts-instagram-dms";
import catalogTips from "./instagram-catalog-tips-photos-sizes";
import safety from "./is-checkout-dm-safe-instagram-oauth";
import manychat from "./manychat-alternatives-instagram-sellers";
import bestFree from "./best-free-instagram-automation-tools";
import featureCompare from "./instagram-dm-automation-feature-comparison";
import automateSales from "./how-to-automate-sales-on-instagram";
import noWebsite from "./sell-on-instagram-without-a-website";
import paymentsIndia from "./take-payments-on-instagram-india";
import digitalProducts from "./sell-digital-products-on-instagram";
import fakeScreenshots from "./avoid-fake-payment-screenshots-instagram-sellers";
import dmTemplates from "./instagram-dm-reply-templates-for-sellers";
import rto from "./reduce-rto-instagram-sellers-india";
import codVsPrepaid from "./cash-on-delivery-vs-prepaid-instagram-sellers";
import returnPolicy from "./return-policy-for-instagram-shop";
import pricing from "./price-products-on-instagram-india";
import packShip from "./pack-and-ship-instagram-orders";
import checkoutEnded from "./instagram-checkout-ended-sell-in-dms";
import dmSafe from "./is-instagram-dm-automation-safe-2026";
import benefits from "./benefits-of-using-checkout-dm-instagram";
import vsShopify from "./checkout-dm-vs-shopify-instagram-sellers";
import vsEtsy from "./etsy-vs-instagram-selling-india";
import productDescriptions from "./write-product-descriptions-instagram-sellers";
import reelsToSales from "./turn-instagram-reels-into-sales";
import sellClothes from "./sell-clothes-on-instagram-india";
import meeshoAmazon from "./meesho-amazon-or-instagram-where-to-sell";
import whatsappCatalog from "./whatsapp-catalog-vs-instagram-dm-checkout";
import metaAgent from "./meta-business-agent-instagram-sellers";
import pricingPlans from "./checkout-dm-pricing-and-plans-explained";
import returnsExchanges from "./returns-and-exchanges-in-instagram-dms";
import discountsShipping from "./discount-codes-and-free-shipping-for-instagram-orders";
import autoShip from "./auto-ship-instagram-orders-shiprocket-shippo";
import analyticsNumbers from "./understand-checkout-dm-analytics-numbers";
import referralProgram from "./checkout-dm-referral-program-earn-free-days";
import stuckPauseBot from "./stuck-tab-and-pause-bot-take-over-instagram-dms";
import catalogPageUpdates from "./public-catalog-page-when-it-updates";
import addTeamMembers from "./add-team-members-to-checkout-dm";
import webhooksGuide from "./checkout-dm-webhooks-for-orders-and-returns";
import bulkUpload from "./bulk-upload-product-photos-checkout-dm";
import statusBadges from "./checkout-dm-status-badges-explained";
import connectRazorpay from "./connect-razorpay-to-checkout-dm";
import withoutShopify from "./sell-on-instagram-without-shopify";
import autoSell247 from "./instagram-page-auto-sell-24x7";
import withoutEtsyFees from "./sell-without-etsy-fees-instagram-flat-monthly-fee";
import collectAddress from "./collect-customer-address-phone-instagram-dms";
import manageOrders from "./manage-instagram-orders-without-spreadsheet";
import autoReplySearch from "./instagram-auto-reply-price-size-questions";
import connectInstagram from "./connect-instagram-business-account-checkout-dm";
import costToSell from "./how-much-does-it-cost-to-sell-on-instagram";
import whichPlan from "./which-checkout-dm-plan-should-you-choose";
import freePlan from "./checkout-dm-free-plan-limits-and-when-to-upgrade";
import realCost from "./what-checkout-dm-really-costs-plan-gateway-fees";
import shopifyAlt from "./shopify-alternatives-india-instagram-sellers";
import etsyAlt from "./etsy-alternatives-india-sellers";
import whatIsDmAuto from "./what-is-instagram-dm-automation";
import dmVsChatbots from "./instagram-dm-automation-vs-chatbots";
import whatToAutomate from "./what-to-automate-in-instagram-dms";
import dmGlossary from "./instagram-dm-automation-glossary";
import dmChecklist from "./instagram-dm-automation-checklist";

/**
 * Post registry. To add an article:
 *   1) create posts/<slug>.js
 *   2) import it here and add it to ALL_POSTS
 *   3) add its images to public/blog-images/
 *   4) add its URL to public/sitemap.xml
 * Order does not matter; posts are sorted by date (newest first).
 *
 * A post whose `date` is in the future stays hidden until that day
 * (UTC midnight, i.e. 5:30 AM IST), so you can queue articles ahead of time.
 */
const ALL_POSTS = [sellOnInstagram, commentToDm, storyReplies, acceptPayments, abandonedCarts, catalogTips, safety, manychat, bestFree, featureCompare, automateSales, noWebsite, paymentsIndia, digitalProducts, fakeScreenshots, dmTemplates, rto, codVsPrepaid, returnPolicy, pricing, packShip, checkoutEnded, dmSafe, benefits, vsShopify, vsEtsy, productDescriptions, reelsToSales, sellClothes, meeshoAmazon, whatsappCatalog, metaAgent, pricingPlans, returnsExchanges, discountsShipping, autoShip, analyticsNumbers, referralProgram, stuckPauseBot, catalogPageUpdates, addTeamMembers, webhooksGuide, bulkUpload, statusBadges, connectRazorpay, withoutShopify, autoSell247, withoutEtsyFees, collectAddress, manageOrders, autoReplySearch, connectInstagram, costToSell, whichPlan, freePlan, realCost, shopifyAlt, etsyAlt, whatIsDmAuto, dmVsChatbots, whatToAutomate, dmGlossary, dmChecklist];

export const AUTHOR = {
  name: "Prince Jindal",
  role: "Founder, Checkout DM",
  initials: "PJ",
  url: "https://www.linkedin.com/in/princejindal/",
};

// "2026-11-02" publishes at 00:00 UTC (5:30 AM IST).
// "2026-11-02T12:00:00Z" publishes at 12:00 UTC (5:30 PM IST).
function publishTime(p) {
  return new Date(p.date.length > 10 ? p.date : `${p.date}T00:00:00Z`).getTime();
}

export function getPublishedPosts() {
  const now = Date.now();
  return ALL_POSTS.filter((p) => publishTime(p) <= now).sort(
    (a, b) => publishTime(b) - publishTime(a)
  );
}

export function getPost(slug) {
  return getPublishedPosts().find((p) => p.slug === slug) || null;
}

export function getRelatedPosts(post, limit = 2) {
  const others = getPublishedPosts().filter((p) => p.slug !== post.slug);
  const same = others.filter((p) => p.category === post.category);
  const rest = others.filter((p) => p.category !== post.category);
  return [...same, ...rest].slice(0, limit);
}

export function getCategories() {
  return Array.from(new Set(getPublishedPosts().map((p) => p.category)));
}

const textOf = (b) =>
  [b.text, b.title, ...(b.items || []), ...(b.rows ? b.rows.flat() : [])]
    .filter(Boolean)
    .join(" ");

export function readingMinutes(post) {
  const words = post.blocks
    .filter((b) => b.type !== "chat" && b.type !== "figure")
    .map(textOf)
    .join(" ")
    .split(/\s+/)
    .filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export function formatDate(iso) {
  return new Date(iso.length > 10 ? iso : `${iso}T00:00:00Z`).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
